module.exports = __webpack_public_path__ + "static/media/login-BG-954px.615f0521.jpg";